import Slider, { Handle } from 'rc-slider';
import { useAppSelector } from '../../../../Hooks/Hooks';
import { RootState } from '../../../../Redux/Store';
import { TSearchSliderProps } from './SearchSlider.type';
import 'rc-slider/assets/index.css';
import './SearchSlider.scss';

const generateMarks = (min: number, max: number, step: number) => {
  const marks = Array.from(
    { length: Math.floor((max - min) / step) + 1 },
    (_, i) => min + i * step,
  );
  if (marks[marks.length - 1] !== max) {
    marks.push(max);
  }
  return marks.reduce((acc, cur) => ({ ...acc, [cur]: '' }), {});
};

const SearchSlider = (props: TSearchSliderProps) => {
  const { labelName, InputValue, name, configId, handleChange, rangeDisabled = false } = props;
  const { configTableData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  const configData = configTableData?.FPO_APP_CONFIG?.[configId?.toUpperCase()];
  const marks = generateMarks(configData?.min, configData?.max, configData?.interval);

  const CustomHandle = (props: any) => {
    const { value, dragging, index, ...restProps } = props;
    if (!value) return <></>;
    return (
      <Handle value={value} {...restProps} className={`rc-slider-handle`}>
        <div className="sliderCustomHandel">
          {value} {configData?.unit}
        </div>
      </Handle>
    );
  };

  const onValueChange = (value: number) => {
    const target = { name, value };
    handleChange(target);
  };

  return (
    <div className={`SearchSlider ${name || ''}`}>
      <div className="SearchSliderLabelAndValue my-3">
        <div className="SearchSliderLabel">{labelName}</div>
        <div className={`SearchSliderValue ${!configData ? 'hidden' : ''}`}>
          {InputValue} {configData?.unit}
        </div>
      </div>
      <div className={`${name || ''} SliderComponent`}>
        <div
          className={`left arrow ${InputValue === configData?.min || rangeDisabled ? 'disabled' : ''} ${!configData ? 'hidden' : ''}`}
          onClick={() => {
            if (!rangeDisabled && InputValue > configData?.min) {
              const updatedValue = InputValue - configData?.interval;
              const target = { name, value: updatedValue };
              handleChange(target);
            }
          }}
        >
          &nbsp;
        </div>
        <div className={`customSlider ${!configData ? 'hidden' : ''}`}>
          <Slider
            min={configData?.min}
            step={configData?.interval}
            max={configData?.max}
            marks={marks}
            handle={CustomHandle}
            value={InputValue}
            disabled={rangeDisabled}
            onChange={onValueChange}
          />
        </div>
        <div
          className={`right arrow ${InputValue === configData?.max || rangeDisabled ? 'disabled' : ''} ${!configData ? 'hidden' : ''}`}
          onClick={() => {
            if (!rangeDisabled && InputValue < configData?.max) {
              const updatedValue = InputValue + configData?.interval;
              const target = { name, value: updatedValue };
              handleChange(target);
            }
          }}
        >
          &nbsp;
        </div>
      </div>
      <div className={`SliderRangeDisplay ${!configData ? 'hidden' : ''}`}>
        <div className="minimumValue">{configData?.min}</div>
        <div className="midValue">{configData?.mid}</div>
        <div className="maximumValue">{configData?.max}</div>
      </div>
    </div>
  );
};

export default SearchSlider;
